import * as AllActions from '@store/actions'
import useActions from './use-actions'

//
export const useAllActions = () => useActions(AllActions)

export default useAllActions
